/************************************
MODULE:         DROPDOWN WITH LINKS SELECTION
WHAT IT DOES:   Dropdown that redirects you to a corresponding page when selected
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function init() {
        var selectWrapper = $('.js-selectlist-with-btn');
        if (!selectWrapper.length)
            return;
        var select = selectWrapper.find('.js-select').first();
        if (!select)
            return;
        var btn = selectWrapper.find('.js-dropdown-btn').first();
        if (!btn)
            return;
        
        btn.on('click', function() {
            var selectedUrl = select.val();
            if (selectedUrl)
                window.location.href = selectedUrl;
        });

        select.on('change', function() {
            var selectedUrl = select.val();
            if (selectedUrl=='') {
                btn.addClass('not-active');
            } else {
                btn.removeClass('not-active');
            }
        })

        if (!window.App.globals.isMobile) {

            var chosenContainer = selectWrapper.find('.chosen-container');
            if (!chosenContainer)
                return;

            chosenContainer.on('click', function() {
                var selectOptions = chosenContainer.find('.chosen-results li');

                selectOptions.each(function() {
                    var selectHtml = $(this).html().split('-&nbsp;');
                    if (selectHtml[1] && !selectHtml[0].includes('<span>')) {
                        var updatedHtml = selectHtml[0] + '<span>-&nbsp;' + selectHtml[1] + '</span>';
                        $(this).html(updatedHtml);
                    }
                });
                
            })

        }
        

        

    }
    
    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.selectlistbtn.js
 ** module id = 56
 ** module chunks = 24
 **/